





















import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop, Emit } from 'vue-property-decorator';

import { IPayment } from '@/interfaces/Payment';
import { IntervalType } from '@/interfaces/IntervalType';
import { ICheckout, ICheckoutCartOffer } from '@/interfaces/Checkout';

import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';

import PlanText from './PlanText.vue';

import { EPaymentMethod } from '@/helpers/enums';
import { Invoice } from '@/classes/Checkout/Invoice';

const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    RadioBox,
    PlanText,
  }
})
export default class Plan extends Vue {
  @Prop()
  private offer!: ICheckoutCartOffer;

  @Prop()
  private active!: boolean;

  @Prop()
  private invoice: any;

  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  @CheckoutModule.Getter
  private rootOfferRelated: any[];

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  private get payment() {
    return this.offer.payment;
  }

  private get bestOfferAB() {
    const hasBestChoiceSet = Boolean(this.rootOfferRelated.find((related) => related.is_best_choice));
    const isRootOffer = this.rootOffer.id === this.offer.id;
    return  this.$route.query.m === '1' && isRootOffer && !hasBestChoiceSet;
  }

  private get title(): string|null|undefined {
    return this.offer.related_offer_title || this.offer.subtitle;
  }
}
